import { loopbackGet, loopbackPatch, loopbackPost } from '..';
import { Feedback } from '../../redux/types';

// eslint-disable-next-line import/prefer-default-export
export const getSurveyFeedbacks = (surveyId: number): Promise<Feedback[]> => {
  const filter = {
    where: { surveyId },
  };

  const uri = `Feedback?filter=${JSON.stringify(filter)}`;
  return loopbackGet(uri);
};

export const getSurveyFeedbacksV2 = (digitalSurveyId: number): Promise<Feedback[]> => {
  const filter = { where: { digitalSurveyId } };
  const uri = `Feedback?filter=${JSON.stringify(filter)}`;
  return loopbackGet(uri);
};

export const submitFeedback = async (feedback: Feedback, submissionId: number): Promise<void> => {
  await loopbackPost('Feedback', feedback);
  await loopbackPatch(`Submissions/${submissionId}`, { feedbackProvided: true });
};

// send feedback for survey from trial v2
export const submitFeedbackV2 = async (feedback: Feedback, smId: number): Promise<void> => {
  await loopbackPost('Feedback', feedback);
  await loopbackPatch(`SurveySubmissionMeta/updateFeedbackProvided/?id=${smId}&feedbackProvided=true`);
};
